import React from 'react';
import styled from 'styled-components';

import { Card, CardProps } from '../Card';

export interface CardPrimaryProps extends CardProps {}

export const CardPrimary = styled(Card)<CardPrimaryProps>`
  color: ${({ theme }) => theme.colors.highlightText};
  background-color: ${({ theme }) => theme.colors.gray[1]};
`;

CardPrimary.defaultProps = {
  rounded: true,
  p: 1,
};

// TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const CardPrimaryDocz = (props: CardPrimaryProps) => {
  return <CardPrimary {...props} />;
};
try {
    // @ts-ignore
    CardPrimary.displayName = "CardPrimary";
    // @ts-ignore
    CardPrimary.__docgenInfo = { "description": "", "displayName": "CardPrimary", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/CardPrimary/CardPrimary.tsx#CardPrimary"] = { docgenInfo: CardPrimary.__docgenInfo, name: "CardPrimary", path: "src/components/CardPrimary/CardPrimary.tsx#CardPrimary" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    CardPrimaryDocz.displayName = "CardPrimaryDocz";
    // @ts-ignore
    CardPrimaryDocz.__docgenInfo = { "description": "", "displayName": "CardPrimaryDocz", "props": { "boxShadow": { "defaultValue": null, "description": "", "name": "boxShadow", "required": true, "type": { "name": "BoxShadowProps" } }, "rounded": { "defaultValue": { value: "true" }, "description": "", "name": "rounded", "required": true, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/CardPrimary/CardPrimary.tsx#CardPrimaryDocz"] = { docgenInfo: CardPrimaryDocz.__docgenInfo, name: "CardPrimaryDocz", path: "src/components/CardPrimary/CardPrimary.tsx#CardPrimaryDocz" };
}
catch (__react_docgen_typescript_loader_error) { }